import React, { useState, useRef, useEffect } from "react";
import larIcon from "../../assets/svg/lar.svg";
import rarIcon from "../../assets/svg/rar.svg";
import downIcon from "../../assets/Vehicles/chevron_down.png";

const Pagination = ({ itemsPerPage, setItemsPerPage, pageCount, handlePageClick, onPageSizeChange, currentPage }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const totalPages = pageCount + 1;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handlePageChange = (page) => {
    if (page >= 0 && page < totalPages) {
      handlePageClick({ selected: page });
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const showMax = 3;
    const startPage = Math.max(0, currentPage - Math.floor(showMax / 2));
    const endPage = Math.min(totalPages - 1, startPage + showMax - 1);

    const adjustedStart = Math.max(0, Math.min(startPage, totalPages - showMax));

    if (adjustedStart > 0) {
      pages.push(0);
      if (adjustedStart > 1) pages.push("...");
    }

    for (let i = adjustedStart; i < Math.min(adjustedStart + showMax, totalPages); i++) {
      pages.push(i);
    }

    if (adjustedStart + showMax < totalPages) {
      if (adjustedStart + showMax < totalPages - 1) pages.push("...");
      pages.push(totalPages - 1);
    }

    return pages;
  };

  return (
    <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
      <div className="d-flex align-items-center">
        <span className="pagination-color">Records per page: &nbsp;</span>
        <div className="position-relative" ref={dropdownRef}>
          <div className="custom-dropdown-select" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
            <span className="bg-white no-of-rows rounded-3 px-3 py-2 d-flex align-items-center gap-2 cursor-pointer shadow-sm">
              {itemsPerPage} <img src={downIcon} alt="" style={{ width: "12px" }} />
            </span>
          </div>
          {isDropdownOpen && (
            <div className="custom-dropdown-menu-pagination" style={{ minWidth: "100%" }}>
              {[10, 25, 50, 75, 100].map((size) => (
                <div
                  key={size}
                  className={`custom-dropdown-item-pagination ${itemsPerPage === size ? "active" : ""}`}
                  onClick={() => {
                    const currentRecordIndex = currentPage * itemsPerPage;
                    const newPage = Math.floor(currentRecordIndex / size);

                    if (onPageSizeChange) onPageSizeChange(size);
                    setItemsPerPage(size);
                    if (handlePageClick) {
                      handlePageClick({ selected: newPage });
                    }
                    setIsDropdownOpen(false);
                  }}
                >
                  {size}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="d-flex align-items-center gap-2">
        <div className="custom-pagination">
          {/* Previous Button */}
          <div className={`custom-pagination-item ${currentPage === 0 ? "disabled" : ""}`} onClick={() => handlePageChange(currentPage - 1)}>
            <img src={larIcon} className="ar3" alt="previous" />
          </div>

          {getPageNumbers().map((page, index) =>
            page === "..." ? (
              <div key={`break-${index}`} className="custom-pagination-break">
                ...
              </div>
            ) : (
              <div key={page} className={`custom-pagination-item ${currentPage === page ? "active" : ""}`} onClick={() => handlePageChange(page)}>
                {page + 1}
              </div>
            ),
          )}

          {/* Next Button */}
          <div className={`custom-pagination-item ${currentPage === totalPages - 1 ? "disabled" : ""}`} onClick={() => handlePageChange(currentPage + 1)}>
            <img src={rarIcon} className="ar3" alt="next" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
